module.exports = __webpack_public_path__ + "static/media/user_agreement_2025_06_06.8b3e4f24.htm";